import { CELERY_STATUSES } from "@shared/constants";
import { getTaskFromJobId, GetTaskFromJobIdReturnType } from "./api";

/**
 * Accepts a job_id and returns a url related to the document being requested
 * @param taskID The job ID to send to the loader api (/api/celery/)
 * @param opts Any additional options for the loader
 */
export const taskLoader = (
  taskID: string,
  opts?: any // eslint-disable-line
): GetTaskFromJobIdReturnType => {
  const newOpts = {
    ...opts,
    delay: opts?.delay ? opts.delay : 2000, // How long to wait in between polls, in milliseconds
    count: opts?.count ? opts.count : 100, // Max number of times to poll
  };

  const statuses = CELERY_STATUSES;

  const poll = () => {
    return Promise.resolve(
      new Promise((resolve, reject) => {
        // Wait specified time
        setTimeout(() => {
          getTaskFromJobId(taskID) // Poll celery task
            .then((response: GetTaskFromJobIdReturnType) => {
              const { state } = response;

              let returnData = null;

              if (state === statuses.SUCCESS.id) {
                // Task complete!
                returnData = resolve(response);
              } else if (
                state === statuses.PENDING.id ||
                state === statuses.RETRY.id
              ) {
                // Continue interval
                returnData = resolve(poll());
              } else if (state === statuses.FAILURE.id) {
                // Failed, return error
                returnData = reject(response);
              } else {
                // Unknown state; return error
                returnData = reject(response);
              }

              return returnData;
            })
            .catch((error) => {
              reject(error);
            });
        }, newOpts.delay);
      })
    ) as unknown as GetTaskFromJobIdReturnType;
  };

  return poll();
};
